import {FC, useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {activeLinkSelecror, menuModeSelecror} from "../../Selectors";
import {setActiveLink, setMenuMode} from "../../store/reducer";
import {NavLink, useLocation, useNavigate} from "react-router-dom";

const HeaderLink: FC<{ name: string}> = ({name}) => {
    return <a>{name}</a>

}

export const Header = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()


    const menuMode = useSelector(menuModeSelecror)
    const [activeLink,setActiveLink] = useState(location.pathname.slice(1))

    useEffect(() => {
        setActiveLink(location.pathname.slice(1))
    },[location])


    const loader = useRef<HTMLDivElement>(null)

    return <>
        <div className={'loader'} ref={loader}>
            {['l','o','a','d'].map((el,idx) => {
                return <div key={idx} style={{transitionDelay:idx*100 + 'ms'}}>{el.toUpperCase()}</div>
            })}
        </div>
        <header className={'header' + (menuMode ? ' active' : '')}>
            <img src="assets/images/particles/pixels1.svg" className={'cubes'} alt=""/>
            <img src="assets/images/particles/pixels2.svg" className={'cubes'} alt=""/>
            <div className="particles">
                <img src="assets/images/particles/pixelsBg.svg" alt="" className="particle"/>
                <img src="assets/images/particles/pixelsBg.svg" alt="" className="particle"/>
                <img src="assets/images/particles/pixelsBg.svg" alt="" className="particle"/>
                <img src="assets/images/particles/pixelsBg.svg" alt="" className="particle"/>
            </div>
            <nav className="header_menu">
                <ul className={"nav" + (menuMode ? ' active' : '')}>
                    {[['домой', ''],
                        ['навыки', 'skills'],
                        ['портфолио', 'portfolio'],
                        ['инфо', 'about'],
                        ['контакты', 'contacts']].map((el,idx) =>
                        <li className={el[1] === location.pathname.slice(1) ? 'active' : ''} key={idx} onClick={() => {
                            dispatch(setMenuMode(false))
                            document.querySelector('body')?.classList.remove('active')
                            loader.current?.classList.add('active')
                            setTimeout(() => {
                                navigate(el[1])
                            },500)
                            setTimeout(() => {
                                loader.current?.classList.remove('active')
                            },1100)
                        }}>
                            <HeaderLink
                                name={el[0]}
                            />
                        </li>)
                        }
                </ul>
                <img onClick={() => {
                    dispatch(setMenuMode(!menuMode))
                    document.querySelector('body')?.classList.toggle('active')
                }} src="./assets/images/burger.png" className={'burger' + (menuMode ? ' active' : '')} alt=""/>
            </nav>
        </header>
    </>
}